import { render, staticRenderFns } from "./commissionRecord.vue?vue&type=template&id=01bb70aa&scoped=true"
import script from "./commissionRecord.vue?vue&type=script&lang=js"
export * from "./commissionRecord.vue?vue&type=script&lang=js"
import style0 from "./commissionRecord.vue?vue&type=style&index=0&id=01bb70aa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bb70aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01bb70aa')) {
      api.createRecord('01bb70aa', component.options)
    } else {
      api.reload('01bb70aa', component.options)
    }
    module.hot.accept("./commissionRecord.vue?vue&type=template&id=01bb70aa&scoped=true", function () {
      api.rerender('01bb70aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/matrix/components/commissionRecord.vue"
export default component.exports